import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import RunsList from '../RunsList/RunsList';

const ReceivedRunModal = ({ showModal, closeModal, confirmModal }) => (
    <Modal show={showModal} bsSize="large">
        <Modal.Header>
            <Modal.Title>Choose received run</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <RunsList onRunClick={confirmModal} />
        </Modal.Body>
        <Modal.Footer>
            <Button
                className="pull-right"
                style={{ marginRight: 20 }}
                bsStyle="default"
                onClick={closeModal}
            >
                Dismiss
            </Button>
        </Modal.Footer>
    </Modal>
);

ReceivedRunModal.propTypes = {
    showModal: PropTypes.bool,
    closeModal: PropTypes.func,
    confirmModal: PropTypes.func,
};
ReceivedRunModal.defaultProps = {
    showModal: false,
};

export default ReceivedRunModal;
